import { SSOService, notificationAuth } from "../../utils/login/request";
import { getProcessedToken } from "../training/request";
import axios from 'axios';

export const userLogin = (data, headers) => {
  return SSOService({
    url: `auth/realms/SimplifyCV/protocol/openid-connect/token`, //SimplifyCV  hire3x-dev
    method: "post",
    headers: headers,
    data,
  });
};

export const userLogOut = (data, headers) => {
  return SSOService({
    url: `auth/realms/SimplifyCV/protocol/openid-connect/logout`,
    method: "post",
    headers: headers,
    data,
  });
};

export const keyCloakLogin = (token) => {
  // return axios.get("https://keynode.simplifycv.com/user-access/",{
  // return axios.get("https://keynode.simplifymycareer.com/user-access/",{
  return axios.get("https://keynode.hire3x.com/user-access/", {
    headers: { "Authorization": `Bearer ${token}` }
  });
}

export const clearNotification = (data) => {
	return notificationAuth({
		method: "delete",
		url: "/app-notification/",
		data,
    headers: {"userID" : getProcessedToken()}
	});
};

